<script lang="ts" setup>
import { useRouter } from 'vue-router'
import AgencyWallet from '~desktop/pages/account/agency-wallet.vue'
import { useUserData } from '~composables/account/use-user-data'
import { AccountTabs } from '~/constants/account'
import { useLogout } from '~/composables/account/use-logout'
import { useTransfer } from '~/composables/transfer/use-transfer'

const { currentUser, currentBalanceFormat, avatar } = useUserData()
const { creditRate, betAccounts } = useTransfer()
const config = useRuntimeConfig()
const router = useRouter()
const { MAIN_CREDIT_UNIT, INDIRECT_BRAND_NAME, INDIRECT_BRAND2_NAME } = config.public
const { submitLogout } = useLogout()
</script>

<template>
  <div class="section-account">
    <div class="ctn-account">
      <div class="ctn-avatar">
        <ClientOnly>
          <img class="img-avatar" :src="avatar" alt="avatar" />
        </ClientOnly>
        <div class="ctn-infor">
          <div class="name line-limit-1">{{ currentUser.fullname }}</div>
        </div>
      </div>

      <div class="ctn-main-wallet">
        <div class="ctn-infor-wallet">
          <div class="icon-wrapper">
            <span class="icon-wallet"></span>
          </div>
          <div class="infor-wallet">
            <div class="title-wallet">
              <div>Ví Chính</div>
              <div class="tooltip-wrapper">
                <img class="icon-info" src="~assets/images/icons/info.svg" alt="question" />

                <div class="tooltip-content" :class="{ active: true }">
                  <div class="tooltip-content__item">Cược trực tiếp trên trang</div>
                </div>
              </div>
            </div>
            <div class="ctn-agency-amount">
              <div class="agency-amount">{{ currentBalanceFormat }} {{ MAIN_CREDIT_UNIT }}</div>
            </div>
          </div>
        </div>
      </div>

      <AgencyWallet
        :agencyName="INDIRECT_BRAND_NAME"
        :creditRate="creditRate"
        iconClass="icon-global"
        :accounts="betAccounts[INDIRECT_BRAND_NAME]"
      />

      <AgencyWallet
        :agencyName="INDIRECT_BRAND2_NAME"
        :creditRate="creditRate"
        iconClass="icon-exchange"
        :accounts="betAccounts[INDIRECT_BRAND2_NAME]"
        color="yellow"
      />
    </div>

    <div class="ctn-account-button">
      <NuxtLink
        class="ctn-account-button-item"
        :class="AccountTabs.INFORMATION.includes(String(router.currentRoute.value?.query?.tab)) && 'active'"
        :to="AccountTabs.INFORMATION"
      >
        <div>
          <img src="/assets/images/icons/account.png" alt="infor" />
          <span>Thông tin cá nhân</span>
        </div>
        <img
          v-if="AccountTabs.INFORMATION.includes(String(router.currentRoute.value?.query?.tab))"
          src="/assets/images/icons/back-active.png"
          alt="infor"
        />
        <img v-else src="/assets/images/icons/back.png" alt="infor" />
      </NuxtLink>
      <NuxtLink
        class="ctn-account-button-item"
        :class="AccountTabs.HISTORY_TRANSACTION.includes(String(router.currentRoute.value?.query?.tab)) && 'active'"
        :to="AccountTabs.HISTORY_TRANSACTION"
      >
        <div><img src="/assets/images/icons/history.png" alt="infor" /> <span> Lịch sử </span></div>
        <img
          v-if="AccountTabs.HISTORY_TRANSACTION.includes(String(router.currentRoute.value?.query?.tab))"
          src="/assets/images/icons/back-active.png"
          alt="infor"
        />
        <img v-else src="/assets/images/icons/back.png" alt="infor" />
      </NuxtLink>
      <div class="ctn-account-button-item" @click="submitLogout()">
        <div><img src="/assets/images/icons/exit.png" alt="infor" /> <span> Đăng xuất </span></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~scssAsset/desktop/pages/account/section-account.scss';
</style>
